import { useEffect, useRef, useState } from "react";

export default function useCategoryScroll({
  groupedProducts,
  isDrawer,
  activeMainTab,
  onMainTabChange,
}) {
  const [activeCategory, setActiveCategory] = useState(null);
  const categoryRefs = useRef({});
  const scrollRootRef = useRef(null);
  const navTabsRef = useRef(null);

  const scrollToCategory = (cat) => {
    const el = categoryRefs.current[cat];
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    if (onMainTabChange) onMainTabChange("groceries");
    setActiveCategory(cat);
  };

  useEffect(() => {
    if (activeMainTab !== "groceries") return;
    if (!groupedProducts.length) return;

    const isInternalScroll = isDrawer && scrollRootRef.current;
    const scrollTarget = isInternalScroll ? scrollRootRef.current : window;

    const compute = () => {
      const baseTop = isInternalScroll
        ? scrollRootRef.current.getBoundingClientRect().top
        : 0;
      const threshold = baseTop + 100;
      let current = groupedProducts[0]?.category || null;

      for (const group of groupedProducts) {
        const el = categoryRefs.current[group.category];
        if (!el) continue;
        const { top } = el.getBoundingClientRect();
        if (top <= threshold) {
          current = group.category;
        } else {
          break;
        }
      }

      setActiveCategory((prev) => (prev === current ? prev : current));
    };

    compute();
    scrollTarget.addEventListener("scroll", compute, { passive: true });
    window.addEventListener("resize", compute);

    return () => {
      scrollTarget.removeEventListener("scroll", compute);
      window.removeEventListener("resize", compute);
    };
  }, [activeMainTab, groupedProducts, isDrawer]);

  useEffect(() => {
    if (!activeCategory || !navTabsRef.current) return;
    const btn = navTabsRef.current.querySelector(
      `[data-category-tab="${CSS.escape(activeCategory)}"]`
    );
    if (btn && btn.scrollIntoView) {
      btn.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [activeCategory]);

  return {
    activeCategory,
    categoryRefs,
    scrollRootRef,
    navTabsRef,
    scrollToCategory,
  };
}
